import { KYMW2600Component } from './kymw2600.component';

/**
 * Ｗ掲載リスト画面の値を管理するクラス
 *
 * @export KYMW2600Model
 * @class KYMW2600Model
 */
export class KYMW2600Model {

  kymw2600Component: KYMW2600Component;

  /** 受注コード */
  public orderCode: string = <string>'';

  /** 部門コード */
  public classCode: string = <string>'';

  /** 生協コード */
  public coopCode: string = <string>'';

  /** 処理区分 */
  public processType: string = <string>'';

  /** 部門・会員生協活性非活性判定 */
  public disabledMediumToFlg: boolean = <boolean> false;

  /** 実行ボタン活性非活性判定 */
  public disabledExecuteToFlg: boolean = <boolean> true;
}
